import React, { useEffect, useState } from 'react';
import {
  Button,
  ButtonGroup,
  Checkbox,
  CssBaseline,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  makeStyles,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { BarChart, Create, Delete } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';
import MUIDataTable from 'mui-datatables';
import swal from '@sweetalert/with-react';
import moment from 'moment';
import axiosInstance, { decryptAES, EVENT_CODE, EVENT_ID, getEventId, WEB_API } from '../constatns';
import AdminTopbar from './AdminTopbar';
import { Auth } from 'aws-amplify';
import Popout from 'react-popout-new';
import AdminFooter from './AdminFooter';
import TableToolBarCustom from '../components/MuiDataTableCustom/TableToolBarCustom';
import TableFilterList from '../components/MuiDataTableCustom/TableFilterList';
import Table from '../components/Table/Table';
import { CountryList } from '../common/CountryList';

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: 800,
    overflow: 'auto',
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: '1px solid rgba(224, 224, 224, 1)',
    },
    '& .MuiTableCell-root': {
      textAlign: 'center',
      fontSize: '13px',
      '& span': {
        display: 'block',
        wordBreak: 'keep-all',
      },
      '& button': {
        fontSize: '13px',
      },
    },
  },
  registerStateTable: {
    '& td:last-child > div': {
      display: 'flex',
      '& > div:first-child': {
        paddingRight: '1em',
      },
      '& > div:last-child': {
        paddingLeft: '1em',
      },
      '& > div:nth-child(2)': {
        padding: '0 1em',
        borderLeft: '1px solid #000',
        borderRight: '1px solid #000',
      },
    },
  },
  chartDialogTitle: {
    '& > .MuiTypography-root': {
      display: 'flex',
      justifyContent: 'space-between',
    },
    '& svg': {
      cursor: 'pointer',
    },
  },
}));

const UserListPage = (props) => {
  const { history } = props;
  const classes = useStyles();
  const [data, setData] = useState();
  const [alldata, setAllData] = useState();
  const [selUser, setSelUser] = useState();
  const [selectFilter, setSelectFilter] = useState('all');
  const [open, setOpen] = useState(false);
  const [openUrl, setOpenUrl] = useState('');
  const [openChart, setOpenChart] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [count, setCount] = useState({});
  const [country, setCountry] = useState([]);

  let cols = [
    {
      name: 'id',
      label: 'No',
      options: {
        filter: false,
        sort: true,
        download: false,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return tableMeta.tableData.length - tableMeta.rowIndex;
        },
      },
    },
    {
      name: 'memNo',
      label: 'RegNum',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
      },
    },

    {
      name: 'email',
      label: 'email',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        download: true,
        display: false,
      },
    },
    {
      name: 'title',
      label: 'Title',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'email',
      label: 'email/ID',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
      },
    },
    {
      name: 'username',
      label: 'Name(KOR)',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'in_name_en',
      label: 'Name(ENG)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {value}
              <div>{'(' + tableMeta.currentTableData[tableMeta.rowIndex].data[tableMeta.columnIndex - 1] + ')'}</div>
            </div>
          );
        },
      },
    },
    {
      name: 'country',
      label: 'Country',
      options: {
        filter: true,
        sort: true,
        viewColumns: false,
      },
    },
    {
      name: 'license',
      label: '면허번호',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
      },
    },
    {
      name: 'positionEn',
      // label: '소속 / Affiliation',
      label: 'Affiliation(ENG)',
      options: {
        filter: false,
        sort: true,
        viewColumns: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div>
              {value}
              <div>{'(' + tableMeta.currentTableData[tableMeta.rowIndex].data[tableMeta.columnIndex + 1] + ')'}</div>
              {/* <div>{'(' + tableMeta.tableData[tableMeta.rowIndex].position + ')'}</div> */}
            </div>
          );
        },
      },
    },
    {
      name: 'position',
      label: 'Affiliation(KOR)',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'kind',
      label: '구분',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'hp',
      label: 'Mobile',
      options: {
        filter: false,
        sort: false,
        viewColumns: false,
        display: false,
      },
    },
    {
      name: 'createdAt',
      label: 'Join Date',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const dt = moment(Number(value));
          return dt.tz('Asia/Seoul').format('YYYY-MM-DD');
        },
      },
    },
    {
      name: 'isPay',
      label: 'Registration',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value === 'R' ? 'O' : 'X';
        },
      },
    },
    {
      name: 'isPaper',
      label: 'Free Paper',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return value ? 'O' : 'X';
        },
      },
    },
    // {
    //   name: 'isAbstract',
    //   label: 'Speaker Abstract',
    //   options: {
    //     filter: false,
    //     sort: true,
    //     customBodyRender: (value, tableMeta, updateValue) => {
    //       return value ? 'O' : 'X';
    //     },
    //   },
    // },
    {
      name: 'id',
      label: '로그인',
      options: {
        filter: false,
        sort: true,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Button color={'primary'} size={'small'} variant={'contained'} onClick={(e) => forceLogin(value)} disableElevation>
              로그인
            </Button>
          );
        },
      },
    },
    {
      name: 'payType',
      label: '무료등록자',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          // console.log(data[tableMeta.rowIndex].id);
          return (
            <Checkbox
              checked={value && value === '무료등록'}
              onChange={(e) => {
                forceRegister(data[tableMeta.rowIndex].id, e.target.checked).then((bool) => {
                  updateValue(bool);
                });
              }}
            />
          );
        },
      },
    },
    {
      name: 'role',
      label: '관리자지정',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Checkbox
              checked={data[tableMeta.rowIndex].role === 'SCRL_MGR'}
              onChange={(e) => {
                handleAdmin(e, tableMeta);
                updateValue(e.target.checked);
              }}
            />
          );
        },
      },
    },
    {
      name: 'id',
      label: '관리',
      options: {
        filter: false,
        sort: true,
        download: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          const isDel = selectFilter === 'cancel';
          return (
            <div>
              <IconButton aria-label="update" onClick={() => setUpdateAction(value, tableMeta, updateValue)}>
                <Create fontSize="small" />
              </IconButton>
              <IconButton aria-label="delete" onClick={() => setDeleteAction(tableMeta)}>
                <Delete fontSize="small" />
              </IconButton>
            </div>
          );
        },
      },
    },
  ];

  const setUpdateAction = (val, meta, updateVal) => {
    if (selectFilter === 'cancel') {
      swal({
        title: '선택한 항목을 복구하시겠습니까?',
        text: '',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          axiosInstance
            .put(`${WEB_API}/user/restore`, {
              eventId: EVENT_ID,
              userId: data[meta.rowIndex].id,
            })
            .then((res) => {
              setSelectFilter('all');
              getUserData();
            })
            .catch((err) => {
              console.error(err);
            });
        }
      });
    } else {
      const lang = meta.tableData[meta.rowIndex].country && meta.tableData[meta.rowIndex].country.indexOf('Korea') !== -1 ? 'kor' : 'eng';
      setOpenUrl(`/#/userinfo?userId=${val}&lang=${lang}&isAdmin=true`);
      setSelUser(data[meta.rowIndex]);
      if (open) {
        setOpen(false);
        setTimeout(function () {
          setOpen(true);
        }, 300);
      } else {
        setOpen(true);
      }
    }
  };

  const setDeleteAction = (meta) => {
    swal({
      title: '정말 삭제하시겠습니까?',
      // text: selectFilter === 'cancel' ? '삭제 후 복구할수 없습니다.' : '',
      text: '사용자는 삭제 후 복구가 불가능합니다!!',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axiosInstance
          .delete(`${WEB_API}/user/?eventId=${EVENT_ID}&userId=${data[meta.rowIndex].id}`)
          .then((res) => {
            setSelectFilter('all');
            getUserData();
            // handleFilter('cancel');
          })
          .catch((err) => {
            console.error(err);
          });

        // if (selectFilter === 'cancel') {
        //   axiosInstance
        //     .delete(`${WEB_API}/user/?eventId=${EVENT_ID}&userId=${data[meta.rowIndex].id}`)
        //     .then((res) => {
        //       setSelectFilter('all');
        //       getUserData();
        //       handleFilter('cancel');
        //     })
        //     .catch((err) => {
        //       console.error(err);
        //     });
        // } else {
        //   axiosInstance
        //     .put(`${WEB_API}/user/del`, {
        //       eventId: EVENT_ID,
        //       userId: data[meta.rowIndex].id,
        //     })
        //     .then((res) => {
        //       getUserData();
        //     })
        //     .catch((err) => {
        //       console.error(err);
        //     });
        // }
      }
    });
  };

  const handleAdmin = (e, meta) => {
    data[meta.rowIndex].role = e.target.checked ? 'SCRL_MGR' : 'SCRL_USR';
    const updateParam = {
      evt: EVENT_ID,
      userId: data[meta.rowIndex].id,
      role: data[meta.rowIndex].role,
    };
    axiosInstance.put(`${WEB_API}/user/`, updateParam).then((data) => {});
  };

  const forceRegister = (id, bool) => {
    return new Promise((resolve, reject) => {
      let swalStr = bool ? '해당 사용자를 무료로 등록하시겠습니까?' : '해당 사용자를 무료등록 해제하시겠습니까?';
      swal({
        title: '',
        text: swalStr,
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          const user = data.find((user) => user.id === id);
          let param = {
            evt: EVENT_ID,
            userId: id,
            lang: user.country === 'Korea, Republic of' ? 'kor' : 'etc',
            amount: 0,
            payType: bool ? '무료등록' : '',
            status: bool ? 'Complete' : '',
            regType: bool ? 'R2' : '',
            isPayUpdate: bool ? 'R' : 'P',
          };
          if (!bool) param['isPay'] = 'P';
          axiosInstance.put(`${WEB_API}/user/registration`, param).then((data) => {
            let cbSwalStr = bool ? '등록되었습니다.' : '등록해제되었습니다.';
            swal(cbSwalStr);
            getUserData();
            resolve(bool);
          });
        }
      });
    });
  };

  const forceLogin = (id) => {
    swal({
      title: '',
      text: '로그인하시겠습니까?',
      icon: 'warning',
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axiosInstance
          .get(`${WEB_API}/user/forceLogin?eventId=${EVENT_ID}&eventCode=${encodeURIComponent(EVENT_CODE)}&userId=${id}`)
          .then((data) => {
            const pwd = decryptAES(data.data[id]);
            Auth.signIn(id, pwd)
              .then((user) => {
                const idToken = user.signInUserSession.idToken;
                sessionStorage.clear();
                sessionStorage.setItem('_in_user_', user.username);
                sessionStorage.setItem('_in_country', idToken.payload['custom:country']);
                sessionStorage.setItem('_in_jwt', idToken.getJwtToken());
                sessionStorage.setItem('_in_sub', user.attributes.sub);
                sessionStorage.setItem('_in_name', idToken.payload['custom:in_name']);
                sessionStorage.setItem('_in_event_id', idToken.payload['event_id']);
                sessionStorage.setItem('_in_role', idToken.payload['custom:role']);
                // login time log
                history.push('/main');
              })
              .catch((err) => {
                console.log(err);
                alert(err.message);
              });
          });
      }
    });
  };

  const options = {
    print: false,
    filterType: 'dropdown',
    viewColumns: false,
    downloadOptions: {
      filename: `member_${moment().valueOf()}.xls`,
    },
    searchText: searchText,
    searchOpen: true,
    selectableRows: 'none',
    customSearch: (searchQuery, currentRow, columns) => {
      let isFound = false;
      data.map((member) => {
        if (member.id === currentRow[0]) {
          for (const [key, value] of Object.entries(member)) {
            if (typeof value === 'string') {
              const val = value.toLowerCase().replace(/ /gi, '').replace(/-/gi, '').replace(/\+/gi, '');
              const search = searchQuery.toLowerCase().replace(/ /gi, '').replace(/-/gi, '').replace(/\+/gi, '');
              if (val.indexOf(search) !== -1) isFound = true;
            }
          }
        }
      });
      return isFound;
    },
    onDownload: (buildHead, buildBody, columns, _data) => {
      const dt = columns.findIndex((d) => d.name === 'createdAt');
      const role = columns.findIndex((d) => d.name === 'role');
      const isPay = columns.findIndex((d) => d.name === 'isPay');
      const isPaper = columns.findIndex((d) => d.name === 'isPaper');
      const isAbstract = columns.findIndex((d) => d.name === 'isAbstract');
      const isFree = columns.findIndex((d) => d.name === 'payType');
      let retVal = [];
      _data.map((_d) => {
        if (dt !== -1) {
          _d.data[dt] = moment(Number(_d.data[dt])).tz('Asia/Seoul').format('YYYY-MM-DD HH:mm');
        }
        if (role !== -1) {
          _d.data[role] = _d.data[role] === 'SCRL_MGR' ? 'Y' : 'N';
        }
        if (isPay !== -1) {
          _d.data[isPay] = _d.data[isPay] === 'R' ? 'Y' : 'N';
        }
        if (isPaper !== -1) {
          _d.data[isPaper] = _d.data[isPaper] ? 'Y' : 'N';
        }
        if (isAbstract !== -1) {
          _d.data[isAbstract] = _d.data[isAbstract] ? 'Y' : 'N';
        }
        if (isFree !== -1) {
          _d.data[isFree] = _d.data[isFree] && _d.data[isFree].indexOf('무료등록') !== -1 ? 'Y' : 'N';
        }
        retVal.push(_d);
        return _d;
      });
      return '\uFEFF' + buildHead(columns) + buildBody(retVal);
    },
  };

  const getUserData = (_isDel) => {
    let url = `${WEB_API}/user/list?eventId=${getEventId()}&limit=-1`;
    if (_isDel) url += '&isDel=true';
    axiosInstance.get(`${url}`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      const arrData = response.data.Items.sort((a, b) => {
        return Number(b.createdAt) - Number(a.createdAt);
      });
      // console.log(arrData);
      setData(arrData);
      if (!_isDel) {
        setAllData(arrData);
      }
    });
  };

  useEffect(() => {
    getUserData();
  }, []);

  const handleClose = () => {
    console.log('Window Close');
    setSelectFilter('all');
    getUserData();
    setOpen(false);
  };

  const handleFilter = (_filter) => {
    setSelectFilter(_filter);
    if (_filter === 'all') {
      setData(alldata);
    } else if (_filter === 'cancel') {
      getUserData(true);
    } else {
      const newData = alldata.filter((d) => {
        return _filter === 'korean' ? d.country === 'Korea, Republic of' : d.country !== 'Korea, Republic of';
      });
      setData(newData);
    }
  };

  const showChart = () => {
    // 총 등록자
    const state = {
      total: 0,
      korean: 0,
      international: 0,
    };
    setCount(state);

    data.map((item) => {
      setCount((prevState) => ({
        ...count,
        total: data.length,
        korean: item.country === 'Korea, Republic of' ? prevState['korean'] + 1 : prevState['korean'],
        international: item.country !== 'Korea, Republic of' ? prevState['international'] + 1 : prevState['international'],
      }));
    });

    // 국가별
    let buff = [];
    for (let i = 0; i < CountryList.length; i++) {
      // if (CountryList[i].name !== 'Korea, Republic of') {
      buff.push({
        name: CountryList[i].name,
        count: 0,
      });
      // }
    }
    if (data) {
      for (let i = 0; i < data.length; i++) {
        for (let j = 0; j < buff.length; j++) {
          if (buff[j].name === data[i].country) {
            buff[j].count += 1;
          }
        }
      }
    }
    setCountry(buff);

    // Modal Open
    setOpenChart(true);
  };

  return (
    <Grid item xs={12}>
      <CssBaseline />
      <AdminTopbar MIdx={1} SIdx={0} />
      <Grid container alignItems={'stretch'} direction="column" style={{ padding: 16 }} className={classes.root}>
        <Grid item>
          <Grid container spacing={4} justifyContent={'flex-start'} alignItems={'center'}>
            <Grid item>
              <h1>Sign-up</h1>
            </Grid>
            <Grid item>
              <ButtonGroup color="primary" disableElevation>
                <Button variant={selectFilter === 'all' ? 'contained' : 'outlined'} onClick={() => handleFilter('all')}>
                  All Member
                </Button>
                <Button variant={selectFilter === 'korean' ? 'contained' : 'outlined'} onClick={() => handleFilter('korean')}>
                  Korean
                </Button>
                <Button variant={selectFilter === 'overseas' ? 'contained' : 'outlined'} onClick={() => handleFilter('overseas')}>
                  Overseas
                </Button>
                {/* <Button variant={selectFilter === 'cancel' ? 'contained' : 'outlined'} onClick={() => handleFilter('cancel')}>
                  Cancel List
                </Button> */}
              </ButtonGroup>
            </Grid>
            <Grid item>
              <Button
                color="primary"
                variant={'outlined'}
                startIcon={<BarChart />}
                disableElevation
                onClick={() => history.push('/admin/memberStatus')}
              >
                통계
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <MUIDataTable
            title={''}
            data={data}
            columns={cols}
            options={options}
            components={{ TableToolbar: TableToolBarCustom, TableFilterList: TableFilterList }}
          />
        </Grid>
      </Grid>
      <AdminFooter />
      {open ? <Popout url={openUrl} title="PRS2021-ADMIN" onClosing={handleClose} options={{ width: 1200, height: 800 }} /> : null}
      {openChart ? (
        <Dialog open={openChart} onClose={() => setOpenChart(false)}>
          <DialogTitle className={classes.chartDialogTitle}>
            Sign-up 통계
            <CloseIcon onClick={() => setOpenChart(false)} />
          </DialogTitle>
          <DialogContent dividers>
            <h3>총 등록자</h3>
            <Table>
              <TableBody className={classes.registerStateTable}>
                <TableRow>
                  <TableCell>등록현황</TableCell>
                  <TableCell>
                    <div>
                      <div>전체 : {count['total']}</div>
                      <div>국내 : {count['korean']}</div>
                      <div>해외 : {count['international']}</div>
                    </div>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <h3>국가별</h3>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>국가명</TableCell>
                  <TableCell>인원</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {country.map(
                  (item) =>
                    item.count > 0 && (
                      <TableRow key={item.name}>
                        <TableCell>{item.name}</TableCell>
                        <TableCell>{item.count}명</TableCell>
                      </TableRow>
                    ),
                )}
              </TableBody>
            </Table>
          </DialogContent>
        </Dialog>
      ) : null}
    </Grid>
  );
};

export default UserListPage;
